import { render, staticRenderFns } from "./Footprint.vue?vue&type=template&id=2863c68e"
import script from "./Footprint.vue?vue&type=script&lang=js"
export * from "./Footprint.vue?vue&type=script&lang=js"
import style0 from "./Footprint.vue?vue&type=style&index=0&id=2863c68e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports